import React from 'react';
import { CreditCardIcon, FileCheck2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function OfferSection() {
  return <section id="adquirir" className="px-5 py-14 md:px-8 md:py-20" data-id="element-123" data-mp="8lu7m4gu18tt">
      <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="deex4tspgzrj">
        <FadeIn className="text-center" data-id="element-125" data-mp="dfgaj4x71ycf">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-126" data-mp="idrj7cbr62t2">
            Acceso completo
          </p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-127" data-mp="mdsavynv4ai2">
            Todo incluido, un solo precio
          </h2>
        </FadeIn>

        <FadeIn className="mt-8 border border-accent/50 bg-charcoal p-6 shadow-[0_16px_40px_rgba(0,0,0,0.25)] md:p-8" data-id="element-128" data-mp="wczo8lulk556">
          <div className="flex flex-col justify-between gap-6 border-b border-white/10 pb-6 sm:flex-row sm:items-end" data-id="element-129" data-mp="2t62swlvzgm8r">
            <div data-id="element-130" data-mp="2y55nfcec7a2h">
              <div className="flex items-center gap-2 text-accent" data-id="element-131" data-mp="2y4mgsru5083r">
                <FileCheck2Icon size={20} aria-hidden="true" data-id="element-132" data-mp="12ojzklxzckqi" />
                <p className="text-xs font-bold uppercase tracking-[0.18em]" data-id="element-133" data-mp="xws90betqf0d">
                  Conversion Elite™
                </p>
              </div>
              <h3 className="mt-3 font-display text-2xl font-bold text-white md:text-3xl" data-id="element-134" data-mp="syi8dlabym7d">
                Tratado práctico de la reforma laboral 2026
              </h3>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-135" data-mp="1llbfqmi86jqc">
              <p className="text-xs uppercase tracking-wider text-stone-500" data-id="element-136" data-mp="1gnjcwxg1ld7d">
                Hoy
              </p>
              <p className="mt-1 text-4xl font-extrabold text-accent" data-id="element-137" data-mp="1cl6g4yj9wpmq">
                AR$ 19.990
              </p>
            </div>
          </div>

          <motion.a href="https://tratado-practico-de-modernizacion-laboral-2026.impultienda.ar/checkout" whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} className="flex w-full items-center justify-center gap-2 px-6 py-4 text-sm font-extrabold uppercase tracking-wide text-ink shadow-[0_10px_30px_rgba(183,142,69,0.2)] transition-colors hover:bg-[#d2ae6e] focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-charcoal md:text-base bg-[#46B745]" data-id="element-138" data-mp="17mbn73rldkow">
            Quiero mi tratado ahora
            <CreditCardIcon size={19} aria-hidden="true" data-id="element-139" data-mp="3ouwkcgqofucj" />
          </motion.a>
          <p className="mt-4 text-center text-xs italic leading-relaxed text-stone-500" data-id="element-140" data-mp="3owzkhtljn3uz">
            La opción elegida por abogados que buscan optimizar su práctica y
            ahorrar horas de trabajo en cada expediente.
          </p>
        </FadeIn>

        <div className="mt-5 grid grid-cols-2 gap-px border border-white/10 bg-white/10 md:grid-cols-4" data-id="element-141" data-mp="316ddm5n9zpmk">
          {[[LockKeyholeIcon, 'Pago seguro'], [ZapIcon, 'Acceso inmediato'], [ShieldCheckIcon, 'Garantía 7 días'], [FileCheck2Icon, 'Material digital']].map(([Icon, label]) => {
          const TrustIcon = Icon as typeof LockKeyholeIcon;
          return <div key={label as string} className="flex flex-col items-center gap-2 bg-ink px-3 py-4 text-center" data-id="element-142" data-mp="2di73v22as4ze">
                <TrustIcon size={17} className="text-accent" aria-hidden="true" data-id="element-143" data-mp="2mivfxr84rv9n" />
                <span className="text-xs font-semibold text-stone-300" data-id="element-144" data-mp="2ijeb900j325j">
                  {label as string}
                </span>
              </div>;
        })}
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-145" data-mp="2rhg9j7svngp4">
          <article className="border border-white/10 bg-charcoal p-5" data-id="element-146" data-mp="366vyci8ulc26">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-147" data-mp="317rmtkygb28o">
              ¿Y si recién comienzo a ejercer?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-stone-400" data-id="element-148" data-mp="3f8c5mh4d8y26">
              Contarás con modelos, contratos, escritos y fundamentos para
              trabajar con mayor seguridad desde tus primeros casos.
            </p>
          </article>
          <article className="border border-white/10 bg-charcoal p-5" data-id="element-149" data-mp="18h7f940cs5g2">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-150" data-mp="1dgado5ltvdf2">
              ¿Y si ya tengo experiencia?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-stone-400" data-id="element-151" data-mp="1maf9l3ftjf1g">
              Reducirás el tiempo de redacción y organización con una
              metodología creada para la práctica profesional diaria.
            </p>
          </article>
          <article className="border border-white/10 bg-charcoal p-5" data-id="element-152" data-mp="uk24iqpp2ieh">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-153" data-mp="ykcjutzdml60">
              ¿Y si no cumple mis expectativas?
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-stone-400" data-id="element-154" data-mp="13lifazkf8mj8">
              Disponés de garantía total de 7 días y el reintegro del 100% del
              importe abonado.
            </p>
          </article>
        </div>
      </div>
    </section>;
}